<template>
  <Banner
    v-if="isInstantlyPublished"
    class="banner"
    icon="error"
    heading="PUBLISHING.MP_INTPUB.HEADING"
    subheading="PUBLISHING.MP_INTPUB.SUBHEADING"
    warning
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Composition } from '@spreadgroup/common-partner-lib/composition';
import {
  CompositionPosType,
  isInstantlyPublished as _isInstantlyPublished,
} from 'commons/api/models/publishingCore/compositionPosStates.ts';
import Banner from 'src/app/components/banners/Banner.vue';

const props = defineProps<{
  composition: Composition;
  relevantPosTypes: CompositionPosType[];
}>();

const isInstantlyPublished = computed(() => {
  return props.relevantPosTypes.some((posState) =>
    _isInstantlyPublished(props.composition, posState),
  );
});
</script>

<style scoped lang="scss"></style>
